import { RootStateWithInjection } from '@restore/store';
import { OHIFViewerModeType } from '@dynamika-shared/types/viewerMode';
import {
  isViewerAllowedToLoadForQC,
  prepareQCStudyState,
} from './modes/QC/QC.selector';
import {
  isViewerAllowedToLoadForReader,
  prepareReaderStudy,
} from './modes/Reader/Reader.selector';
import { StudyType } from '@dynamika-shared/services/communication';
import { readerTaskOrchestrationSlice } from '../readerTaskOrchestration/readerTaskOrchestration.slice';
import {
  isViewerAllowedToLoadForSimple,
  prepareSimpleStudyState,
} from './modes/SimpleViewer/SimpleViewer.selector';

export const isViewerAllowedToLoad = (mode: OHIFViewerModeType) => {
  switch (mode) {
    case OHIFViewerModeType.IMAGING_SPECIALIST:
      return isViewerAllowedToLoadForQC;
    case OHIFViewerModeType.SIMPLE_VIEWER:
      return isViewerAllowedToLoadForSimple;
    case OHIFViewerModeType.READER:
      return isViewerAllowedToLoadForReader;
    default:
      throw new Error('Unknown viewer mode');
  }
};

export const prepareStudyState = (
  mode: OHIFViewerModeType
): ((
  r: RootStateWithInjection<[typeof readerTaskOrchestrationSlice]>
) => StudyType) => {
  switch (mode) {
    case OHIFViewerModeType.IMAGING_SPECIALIST:
      return prepareQCStudyState;
    case OHIFViewerModeType.SIMPLE_VIEWER:
      return prepareSimpleStudyState;
    case OHIFViewerModeType.READER:
      return prepareReaderStudy;
    default:
      throw new Error('Unknown viewer mode');
  }
};
